export const UPDATE_EVENTS = "UPDATE_EVENTS";

export const updateEvents = (value) => ({
  type: UPDATE_EVENTS,
  value,
});
